const MiniHeroSection = ({ titleText, sectionClassExtra, iconName }) => {
  const classContent =
    'mini-hero-section py-3' +
    (sectionClassExtra != null && sectionClassExtra.length > 0
      ? ' ' + sectionClassExtra
      : '');
  const classIconContent =
    'mini-hero-overlay fa-solid fa-2x' +
    (iconName != null && iconName.length > 0 ? ' ' + iconName : '');

  return (
    // <section className={classContent}>
    //   <div className="container mini-hero-container">
    //     <h2>{titleText}</h2>
    //     <i className={classIconContent} />
    //   </div>
    // </section>

    <section className={classContent}>
      <div className="container d-flex flex-row justify-content-between align-items-center">
        <h2>{titleText}</h2>
        <i className={classIconContent} />
      </div>
    </section>
  );
};

export default MiniHeroSection;
